// Given a list of objects that have some kind of name, return the first one,
// sorted alphabetically.
export function deriveSortName<T>({
    objs,
    getKey,
}: {
    objs: T[];
    getKey: (obj: T) => string | null | undefined;
}) {
    return (
        objs
            .map((obj) => getKey(obj))
            .sort((a, b) => {
                if (a == null && b == null) {
                    return 0;
                }
                if (a == null) {
                    return 1;
                }
                if (b == null) {
                    return -1;
                }
                return a.localeCompare(b);
            })[0] ?? ''
    );
}
